import React from "react";
import { Link } from "react-router-dom";

// (Components)
import Spacer from "../components/Spacer";

import walletConnectLogo from "../assets/logo.png";

const Navbar = () => {
  return (
    <section className="w-full bg-transparent shadow-sm">
      <Spacer>
        <div className="w-full py-6">
          <div className="logo-image">
            <Link to="/">
              <img
                src={walletConnectLogo}
                alt="wallet conect logo"
                className="w-40"
              />
            </Link>
          </div>
        </div>
      </Spacer>
    </section>
  );
};

export default Navbar;
